module.exports = __webpack_public_path__ + "static/media/BetterGroceriesPublic.da63f3cf.png";